import { memo } from "react";
import { useHistory } from "react-router-dom";

const NewCustomModal = memo((props) => {
  const {
    closeModal,
    isOpen = false,
    title = "",
    children,
    width,
    height,
    showBackIcon = false,
    backPath,
    hideXIcon = false,
    size = "large",
    btnPath,
    buttonLabel = "Go",
    buttonWidth = "120px",
    buttonHeight = "40px",
  } = props;

  const history = useHistory();

  if (!isOpen) return null;

  const handleRedirect = () => {
    if (btnPath) {
      history.push(btnPath);
    }
  };

  const handleBack = () => {
    if (backPath) {
      history.push(backPath);
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
        width: "100%",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0, 0, 0, 0.5)",
        }}
        onClick={closeModal}
      />

      <div
        style={{
          position: "relative",
          background: "white",
          borderRadius: "8px",
          zIndex: 60,
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.2)",
          height: height || "90vh",
          overflowY: "auto",
          transition: "all 0.3s ease",
          textAlign: "center",
          padding: size === "medium" ? "1rem" : "2rem",
          minWidth: !width ? "100%" : undefined,
          width: width || "auto",
        }}
      >
        {showBackIcon && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: "1rem",
              textAlign: "left",
              justifyContent: "flex-start",
            }}
            onClick={handleBack}
          >
            <span
              style={{
                marginRight: "0.5rem",
                fontSize: "2rem",
              }}
            >
              &#8592;
            </span>
          </div>
        )}

        <div
          style={{
            width: "100%",
            marginTop: "0.5rem",
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "left",
            }}
          >
            {title}
          </h2>
        </div>

        {!hideXIcon && (
          <button
            onClick={closeModal}
            style={{
              position: "absolute",
              top: "1.25rem",
              right: "1.25rem",
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            &times;
          </button>
        )}

        <div
          style={{
            marginTop: "1.5rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {children}

          {btnPath && (
            <button
              style={{
                backgroundColor: "#b50503",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: 500,
                fontSize: "1rem",
                transition: "background-color 0.3s ease",
                textAlign: "center",
                width: buttonWidth,
                height: buttonHeight,
                marginTop: "1rem",
              }}
              onClick={handleRedirect}
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#7e0402")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "#b50503")
              }
            >
              {buttonLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
});

export default NewCustomModal;
